<div class="overflow-auto mb-2">
  <table class="w-100 f-14 paid_slip">
    <tr class="f-14 th-border">
      <!-- <th class="text-start"></th> -->
      <th class="text-center" *ngIf="pRefundModalPageOne"></th>
      <th class="text-center">{{ "Qty" | translate | async }}</th>
      <th class="text-start">{{ "Items" | translate | async }}</th>
      <th class="text-end">{{ "Amount" | translate | async }}</th>
    </tr>

    <ng-container *ngFor="let product of paymentReceipt.orderId.seats">
      <tr *ngFor="let variants of product.orderProducts; let i = index">
        <td *ngIf="pRefundModalPageOne" class="text-center">
          <ng-container *ngIf="pRefundModalPageOne">
            <input
              [disabled]="
                variants.productSellStatus === 7 ||
                variants.productSellStatus === 6
              "
              class="red-chek form-check-input"
              type="checkbox"
              value=""
              [id]="'flexCheckChecked' + i"
              [checked]="isCheckedFunc(variants)"
              (click)="addProductsInListToRefundFunc(variants, $event)"
            />
          </ng-container>
        </td>

        <td
          class="text-center"
          *ngIf="variants.productQuantity"
          [ngClass]="{
            'text-danger':
              variants.productSellStatus === 7 ||
              variants.productSellStatus === 6
          }"
        >
          <ng-container
            *ngIf="
              !variants.splitOrderIds || variants.splitOrderIds.length === 0
            "
          >
            <ng-container *ngIf="!pRefundModalPageOne">
              {{ variants.productQuantity }}
            </ng-container>
            <!-- Add nested loop for paymentReceiptCopy -->
            <!-- <ng-container *ngIf="paymentReceiptCopy">
      <ng-container *ngFor="let copyProduct of paymentReceiptCopy.orderId.seats">
        <ng-container *ngFor="let copyVariants of copyProduct.orderProducts; let j = index">
          <ng-container *ngIf="j === i && !pRefundModalPageOne">
            {{ copyVariants.productQuantity }}
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container> -->

            <select
              [disabled]="variants.productSellStatus === 7 || variants.productSellStatus === 6"
              *ngIf="pRefundModalPageOne"
              (ngModelChange)="addProductsInListToRefund2(variants, $event)"
              [(ngModel)]="selectedQuantity[variants.orderedProductId]"
            >
              <option
                *ngFor="let quantity of getQuantityList(variants)"
                [value]="quantity"
              >
                {{ quantity }}
              </option>
            </select>
          </ng-container>
          <ng-container
            *ngIf="
              variants.splitOrderIds &&
              variants.splitOrderIds.length !== 0 &&
              variants.productQuantity === variants.splitOrderIds.length
            "
          >
            1
          </ng-container>
          <!-- variants.productQuantity !== variants.splitOrderIds.length &&
          variants.splitOrderIds.length !== 1 -->
          <ng-container
            *ngIf="
              variants.splitOrderIds &&
              variants.splitOrderIds.length !== 0
            "
          >
            <select
              *ngIf="pRefundModalPageOne"
              (ngModelChange)="addProductsInListToRefund2(variants, $event)"
              [(ngModel)]="selectedQuantity[variants.orderedProductId]"
            >
              <option
                *ngFor="let quantity of getQuantityList(variants)"
                [value]="quantity"
              >
                {{ quantity }}
              </option>
            </select>
            <ng-container *ngIf="!pRefundModalPageOne">
              {{ variants.productQuantity }}
            </ng-container>
            /{{ variants.splitOrderIds.length }}
          </ng-container>
          <ng-container
            *ngIf="
              variants.splitOrderIds &&
              variants.splitOrderIds.length !== 0 &&
              variants.productQuantity !== variants.splitOrderIds.length &&
              variants.splitOrderIds.length === 1
            "
          >
            {{ variants.productQuantity }}
          </ng-container>
          <!-- <ng-container
            *ngIf="
              variants.splitOrderIds &&
              variants.splitOrderIds.length !== 0 &&
              variants.productQuantity !== variants.splitOrderIds.length &&
              variants.splitOrderIds.length === 1
            "
          >
            {{ variants.productQuantity }}
          </ng-container> -->
                   <!-- For Showing the Discount Arrow -->
                   <!-- <ng-container
                   *ngIf="product.productDiscountValue > 0"
                 >
                   DA
                 </ng-container> -->
        </td>

        <td>
          <div
            [ngClass]="{
              ' text-danger':
                variants.productSellStatus === 7 ||
                variants.productSellStatus === 6
            }"
            class="f-14 fw-600"
            [style.text-decoration]="validateProductRefunded(variants)"
          >
            {{
              (variants.productName == ""
                ? variants.productVariantName
                : variants.productName) | translate | async
            }}
          </div>
          <div
            *ngIf="variants.productVariantName"
            [ngClass]="{
              ' text-danger':
                variants.productSellStatus === 7 ||
                variants.productSellStatus === 6
            }"
            class="f-14 fw-500"
            [style.text-decoration]="validateProductRefunded(variants)"
          >
            - {{ variants.productVariantName | translate | async }}
          </div>

          <!-- SHOWING DISCOUNT -->
          <ng-container *ngIf="variants.productDiscountValue">
            <ng-container>
              <div class="f-14 fw-500 d-flex justify-content-between">
                <div>{{ "Discount" | translate | async }}
                  <br>
                  <span style="font-size: 14px;" class="fw-500">
                  {{ getDiscountNames(variants.productDiscount) | translate | async }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="variants.AllproductModifiers">
            <ng-container *ngFor="let modifiers of variants.modifierGroupById">
              <div class="f-14 fw-500 d-flex justify-content-between">
                <div>
                  {{ modifiers.modifierName | translate | async }}
                </div>
              </div>
              <ul *ngIf="modifiers.modifierOptions">
                <li *ngFor="let option of modifiers.modifierOptions">
                  {{ option.modifierOptionName | translate | async }}
                </li>
              </ul>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="variants.productAddons">
            <ng-container *ngFor="let addons of variants.productAddons">
              <div class="f-14 fw-500" *ngIf="addons.addonName">
                {{ addons.addonName | translate | async}}
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="variants.productIngredients">
            <ng-container
              *ngFor="let ingredient of variants.productIngredients"
            >
              <div
                [style.text-decoration]="validateProductIngredients(ingredient)"
                class="f-14 fw-500"
                *ngIf="ingredient.ingredientName"
              >
                {{ ingredient.ingredientName | translate | async }}
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="variants.note">
            <div class="f-14 text-secondary">"{{ variants.note | translate | async }}"</div>
          </ng-container>
        </td>

        <td class="text-end">
          <div
            class="f-14 fw-600"
            [style.text-decoration]="validateProductRefunded(variants)"
            [ngClass]="{
              ' text-danger':
                variants.productSellStatus === 7 ||
                variants.productSellStatus === 6
            }"
          >
            {{
              getPriceForRecipe(
                variants.productUnitPrice,
                variants.productQuantity
              ) | currency : currency : "symbol" : "1.2-2"
            }}
          </div>
          <!--  -->
          <!-- <ng-container *ngIf="variants.productDiscountValue">
            <ng-container>
              <div
                class="f-14 fw-600"
              >
                {{
                  variants.productDiscountValue
                    | currency : currency : "symbol" : "1.2-2"
                }}
              </div>
            </ng-container>
          </ng-container> -->
          <!--  -->
          <!--  -->
          <ng-container *ngIf="variants.productDiscountValue && variants.AllproductModifiers">
            <ng-container>
              <div><br>
                <br>
              </div>
            </ng-container>
          </ng-container>
          <!--  -->
          <ng-container *ngIf="variants.AllproductModifiers">
            <ng-container *ngFor="let modifiers of variants.modifierGroupById">
              <div
              >
                <!-- {{
                  modifiers.modifierTotalPrice
                    | currency : currency : "symbol" : "1.2-2"
                }} -->
                <br>
              </div>
              <div *ngFor="let option of modifiers.modifierOptions"
                class="f-14 fw-600"
                [ngClass]="{
                  ' text-danger':
                    variants.productSellStatus === 7 ||
                    variants.productSellStatus === 6
                }"
              >
                {{
                  option.modifierPrice
                    | currency : currency : "symbol" : "1.2-2"
                }}
              </div>
              <!-- If mod Length is > 1 Break the Line -->
              <div *ngIf="variants.modifierGroupById.length > 1">
                <br>
              </div>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-container>
  </table>
</div>
